import React, { useEffect } from 'react'
import Navbar from '../Navbar';
import {Box, Button, TextField,Grid,Divider, Typography} from '@mui/material';
import { useState } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link, useNavigate,useParams } from 'react-router-dom';
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from '@mui/material/styles';
import { Stack } from '@mui/material';
function EditList(props) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [monthInput, setMonth] = useState({
        month_name: '',
        year: '',
        is_closed:'',
        error_list:[],
    });
    const [error, setError] = useState({
        month_name: '',
        year: '',
        is_closed:'',
       error_list:[],
  });

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor('#F40B27'),
      apple: createColor('#A38A00'),
      steelBlue: createColor('#5C76B7'),
      violet: createColor('#BC00A3'),
    },
    button: { // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    }, 
  });
  

  const {id} = useParams();
  useEffect(()=>{
      const listmonth_id=id;
      axios.get(`/api/edit_listmonth/${listmonth_id}`).then(res=>{
          if(res.data.status===200){
            setMonth(res.data.listmonth);
          }
          else if(res.data.status === 404){
              swal("Error",res.data.message,"error");
              navigate('/certificates/show_listmonth');
          }
          setLoading(false);
      });
  }, [id,navigate]);



  const handleInput = (e) => {
    e.persist();
    setMonth({...monthInput,[e.target.name]: e.target.value});

}
if(loading){
    swal({
      title: 'Loading',
      text: 'Please Wait!!!',
      timer: 1000,
      buttons: false,
    }).then(
      function () {},
      // handling the promise rejection
      function (dismiss) {
        if (dismiss === 'timer') {
          //console.log('I was closed by the timer')
        }
      }
    )
  }
  



  const updatelistmonth= (e) => {
    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);
    const listmonth_id=id;
    const data ={
        month_name: monthInput.month_name,
        year: monthInput.year,
        is_closed:monthInput.is_closed,
        user_id:userId,
    }
    axios.put(`/api/update_listmonth/${listmonth_id}`,data).then(res=>{
        if(res.data.status === 200){
            swal("Success",res.data.message,"success");
            setError([]);
            navigate('/certificates/show_listmonth');
        }
        else if(res.data.status === 422){
            // swal("All fields are mandatory","","error");
            setError({...monthInput, error_list:res.data.errors});
        }
        else if(res.data.status === 404){
            swal("Error",res.data.message,"error");
            navigate('/certificates/show_listmonth');
        }
    });
  } 


      return (
        
        <div>
             <form onSubmit={updatelistmonth} id="CATEGORY_FORM">
             <div className="row" style={{ marginTop: 20, width: "97%" }}>
                             // <div className="col-sm-1"></div>
                             <div className="col-sm-12" style={{ marginLeft: 40 }}>
                                 <div className="card">
                                     <div className="card-header">
                                     <div class="d-flex justify-content-between">
                                <h4><b>Edit Month</b></h4>
                                <ThemeProvider theme={theme}>
           <Button component={Link} to="/certificates/show_listmonth" variant='contained' color='apple'>Back</Button>
           </ThemeProvider></div>
                                     </div>
                                    
                                     <div className="card-body">
                                         <div className="row">
                                             <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                                 <div className="form-group ">
                                                     <label className="required" style={{ marginBottom: "7px" }}>Month_name</label>
                                                     <select name="month_name" id="month_name" className="form-control"  onChange={handleInput} value={monthInput.month_name} disabled={true} >
                                                         <option value="">-- Month Name--</option>
                                                         <option value="January">January</option>
                                                         <option value="February">February</option>
                                                         <option value="March">March</option>
                                                         <option value="April">April</option>
                                                         <option value="May">May</option>
                                                         <option value="June">June</option>
                                                         <option value="July">July</option>
                                                         <option value="August">August</option>
                                                         <option value="September">September</option>
                                                         <option value="October">October</option>
                                                         <option value="November">November</option>
                                                         <option value="December">December</option>
                                                     </select>
                                                     <span style={{ color: "red" }}>
                                                       {error.error_list.month_name}
                                                     </span>
                                                 </div>
                                             </div>
                                             <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                        <div className="form-group ">
                                                <label className="required" style={{ marginBottom: "7px" }}>year</label>
                                                <input type="text" name="year" id="year" className="form-control" placeholder="Enter year" onChange={handleInput} value={monthInput.year} disabled={true} />
                                                <span style={{ color: "red" }}>
                                                {error.error_list.month_name}
                                                </span>
                                            </div>
                                        </div>
                                             <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                                             <div className="form-group ">
                                                     <label className="required" style={{ marginBottom: "7px" }}>is_closed</label>
                                                     <select name="is_closed" id="is_closed" className="form-control"  onChange={handleInput} value={monthInput.is_closed} >
                                                         <option value="">-- is_closed  --</option>
                                                         <option value="0">OPEN</option>
                                                         <option value="1">CLOSE</option>
                                                        
                                                     </select>
                                                     <span style={{ color: "red" }}>
                                                       {error.error_list.is_closed}
                                                     </span>
                                                 </div>
                                             </div>
                                            
                                             
                                         </div >
     
                                         {/* --------------------Item details Add more Display data Start ----------------*/}
                                         
                                         {/* --------------------Item details Add more Display data End ----------------*/}
                                     </div>
                                     <div className="card-footer text-center"> <button type="submit" id="submit" style={{ backgroundColor: "#A38A00", color: "white" }} className="btn btn-default text-center" disabled={false}>Update</button></div>
                                 </div>
                                 
                             </div>
                             
                         </div>
                    </form>
                    </div>
                    
       );
     }
     
     
     
     export default EditList
    



